
export const sortByParams = (sortBy) => {
  if (sortBy) return sortBy;
  return document.querySelector('[data-sortby]').dataset.sortby;
}
export const listingLayoutParams = (listingLayout) => {
  if (listingLayout) return listingLayout;
  let layoutSelector = document.querySelector('[data-listing-layout]');
  return (document.querySelector('[data-listing-layout]') != null) ? document.querySelector('[data-listing-layout]').dataset.listingLayout : 'normal';
}

export const buildQuery = ()=>{
  const replaceString = new RegExp('[=\&]', 'g');
  return $(document.querySelector('[data-filters]').dataset.filtersForm).serialize().replace(replaceString, ':');
}

export const buildFullQuery=({textSearch='',size=36,query,page,sortBy,listingLayout})=>{
  const q = query //|| buildQuery();
  const textsearch = textSearch ? `text=${textSearch}&size=${size}&` : '';
  const sortByParams1 = sortByParams(sortBy);
  const base = `?${textsearch}${listingLayoutParams(listingLayout)}=true&save=false&sort=${sortByParams1}${page?'&page='+page:''}&isRefineSearch=true`;
  return `${base}${q ? `&q=%3A${sortByParams1}%3A${q}` : `&q=%3A${sortByParams1}&resetQuery=true`}`;
}

export const addPreloadParam=(query)=>{
  let preload = 'preload';
  let preloadAttribute = (query.includes('?') ? '&' : '?') + preload + '=true';
  return query.includes(preload) ? query : query + preloadAttribute;
}
